<template>
  <span class="botao-recusar-cotacao">
    <v-btn
      v-if="idApolice"
      v-bind="estiloBotao"
      :disabled="botaoDesabilitado"
      @click="dialogRecusa = true"
    >
      RECUSAR COTAÇÃO
    </v-btn>
    <v-dialog v-model="dialogRecusa" persistent max-width="550">
      <ModalRecusarCotacao
        v-if="dialogRecusa"
        :idApolice="parseInt(idApolice)"
        @fecharModalRecusa="dialogRecusa = false"
      />
    </v-dialog>
  </span>
</template>

<script>
import ModalRecusarCotacao from "./ModalRecusarCotacao.vue";

export default {
  name: "BotaoRecusarCotacao",
  components: { ModalRecusarCotacao },
  props: {
    idApolice: {
      type: [Number, String],
      default: null
    },
    idPropostaStatus: {
      type: [Number, String],
      default: null
    },
    variant: {
      type: String,
      default: "footer"
    }
  },
  data() {
    return {
      dialogRecusa: false,
      statusRecusaDesabilitada: [3, 4, 5, 7, 10, 12]
    };
  },
  computed: {
    estiloBotao() {
      if (this.variant === "toolbar") {
        return { color: "red", dark: true };
      }
      return { color: "primary", outline: true };
    },
    botaoDesabilitado() {
      return this.statusRecusaDesabilitada.includes(
        parseInt(this.idPropostaStatus)
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/frota/BotaoRecusarCotacao.vue